import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Calculates score based on correctness and time to answer
 */
export function calculateScore(
  isCorrect: boolean,
  timeToAnswer: number,
  timeLimit: number,
  maxPoints: number
): number {
  if (!isCorrect) return 0;
  
  const timeRatio = Math.max(0, (timeLimit * 1000 - timeToAnswer) / (timeLimit * 1000));
  return Math.round(maxPoints * timeRatio);
}

/**
 * Generates a random 6-character join code
 */
export function generateJoinCode(): string {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let result = '';
  for (let i = 0; i < 6; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return result;
}

/**
 * Validates a quiz JSON structure
 */
export function validateQuizJSON(json: any): boolean {
  try {
    // Check if required fields exist
    if (!json.title || !json.questions || !Array.isArray(json.questions)) {
      return false;
    }
    
    // Check each question
    for (const question of json.questions) {
      if (!question.text || !question.options || !Array.isArray(question.options)) {
        return false;
      }
      
      // Ensure there are exactly 4 options
      if (question.options.length !== 4) {
        return false;
      }
      
      // Ensure at least one option is correct
      if (!question.options.some((option: any) => option.isCorrect)) {
        return false;
      }
      
      // Ensure each option has text
      for (const option of question.options) {
        if (!option.text || typeof option.isCorrect !== 'boolean') {
          return false;
        }
      }
    }
    
    return true;
  } catch (error) {
    return false;
  }
}